module.exports = __webpack_public_path__ + "assets/img/f137377943be963f5f75eb8a2ac6c6dc.png";